module.exports = __webpack_public_path__ + "img/4.34713f03.png";